export default function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ../~/rc-util/es/Dom/contains.js
// module id = 977
// module chunks = 3